module.exports = __webpack_public_path__ + "static/media/test_display.774f78a4.gif";